import {FC} from 'react'
import Skeleton from 'react-loading-skeleton'

interface Props {
  length?: number
}

export const SkeletonModal: FC<Props> = ({length}) => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
      {Array.from({length: length ?? 1}).map((_, idx) => (
        <div key={idx}>
          <Skeleton count={1} height={30} width='25%' />
          <Skeleton count={1} height={30} width='50%' />
          <Skeleton count={1} height={30} width='100%' />
          <Skeleton count={1} height={30} width='100%' />
          <Skeleton count={1} height={30} width='75%' />
        </div>
      ))}
    </div>
  )
}

SkeletonModal.defaultProps = {
  length: 1,
}
